import Image from 'next/image'
import Link from 'next/link'

const productLinks = [
  ['Home', '/'],
  ['How it works', '/#how-it-works'],
  ['What you can create', '/features'],
  ['Pricing', '/pricing'],
] as const

const companyLinks = [
  ['About', '/about'],
  ['Contact', '/contact'],
] as const

const legalLinks = [
  ['Privacy Policy', '/privacy'],
  ['Terms of Service', '/terms'],
  ['Cookie Policy', '/cookies'],
  ['Data protection', '/gdpr'],
] as const

function FooterLinkGroup({ title, links }: { title: string; links: readonly (readonly [string, string])[] }) {
  return (
    <div>
      <h2 className="text-lg font-semibold text-white">{title}</h2>
      <ul className="mt-4 space-y-2">
        {links.map(([label, href]) => (
          <li key={href}><Link href={href} className="text-sm text-gray-300 transition-colors hover:text-white">{label}</Link></li>
        ))}
      </ul>
    </div>
  )
}

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="max-w-xs">
            <Image src="/brand/skill-bridger-horizontal-reversed.svg" alt="Skill Bridger" width={144} height={40} className="h-8 w-auto" />
            <p className="mt-4 text-sm leading-6 text-gray-300">Turn coursework into portfolio cases, resume bullets, and LinkedIn drafts grounded in work you already completed.</p>
            <p className="mt-4 text-sm text-gray-300">Skill Bridger is a product of Phazon Labs LLC.</p>
          </div>
          <FooterLinkGroup title="Product" links={productLinks} />
          <FooterLinkGroup title="Company" links={companyLinks} />
          <FooterLinkGroup title="Legal" links={legalLinks} />
        </div>
        <div className="mt-10 border-t border-gray-800 pt-8 text-sm text-gray-400">© 2026 Phazon Labs LLC</div>
      </div>
    </footer>
  )
}
